import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';
import {getUrlParameters} from '../../common/util/urlParameters';

export const fetchProvidersOrdersManagement = (filters) => {
  const allFilters = getUrlParameters(filters);

  return apiActionCreator({
    'endpoint': `/orders/providers/administration${allFilters}`,
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_PROVIDERS_ORDERS_MANAGEMENT_LIST,
      ActionTypes.FETCHED_PROVIDERS_ORDERS_MANAGEMENT_LIST,
      [
        ActionTypes.FETCHED_PROVIDERS_ORDERS_MANAGEMENT_LIST_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'GET',
  });
};

export const changeProvidersOrdersManagementListPage = (value) => ({
  'type': ActionTypes.CHANGE_PROVIDERS_ORDERS_MANAGEMENT_LIST_PAGE,
  'payload': value,
});

export const changeProvidersOrdersManagementListPageSize = (value) => ({
  'type': ActionTypes.CHANGE_PROVIDERS_ORDERS_MANAGEMENT_LIST_PAGE_SIZE,
  'payload': value,
});
